import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import AppHeader from '../../../components/AppHeader';
import portalServices from '../../../portalServices';
import ConsultationTimeline from '../components/ConsultationTimeline';
import { LinearProgress } from '@mui/material';
import OTPLoginPage from '../../../components/OTPLoginPage';
import AppFooter from '../../../components/AppFooter';

function ConsultancyListPage() {

    const {customerId} = useParams();
    const [customerToken,setCustomerToken] =  useState(localStorage.customerToken);

    const [loading,setLoadingStatus] =  useState(false);
    const [consultationList,setConstltationList] = useState([])

    const getConsultationList = () =>{
        if(customerToken){
            let payload = {
                customerToken : customerToken,
                customerId:customerId,
            }
            setLoadingStatus(true);
            portalServices.getConsultationList(payload).then(res=>{
                setConstltationList(res.data);
            }).catch(error=>{
            }).finally(()=>{
                setLoadingStatus(false);
            })
        }
    }

    useEffect(()=>{
        getConsultationList();
    },[customerToken])

    

    return (
        <>
            <AppHeader></AppHeader>
             <div className='container'>
             {
                    (customerToken === null || customerToken === undefined)?
                        <OTPLoginPage
                        setCustomerToken={setCustomerToken}
                        /> 
                    :
                    <div className='row mt-4'>
                        {!loading  ?
                        
                            <div className='col-l-md-12'>
                                {consultationList.length > 0 ?
                                    <ConsultationTimeline consultationList={consultationList} />
                                    :
                                    <h3 className='text-center'>No Record Found</h3>
                                }
                                
                            </div>
                            :
                            <div className='col-l-md-12'>
                                <LinearProgress/>
                            </div>
                        }
                    </div>
             }
             </div>
             <AppFooter/>
        </>
    )
}

export default ConsultancyListPage